
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface ComponentsHeaderProps {
  onNewComponent: () => void;
}

export function ComponentsHeader({ onNewComponent }: ComponentsHeaderProps) {
  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
      <div>
        <h1 className="text-3xl font-bold tracking-tight text-foreground">Componentes</h1>
        <p className="text-muted-foreground">
          Gerencie os componentes arquiteturais da sua organização.
        </p>
      </div>
      <Button 
        onClick={onNewComponent}
        className="bg-primary hover:bg-primary/90"
      >
        <Plus className="mr-2 h-4 w-4" /> Novo Componente
      </Button>
    </div>
  );
}
